// Copyright (c) 2017 Deere & Company

import {
    getClaimTypesList,
    onCreateClaim,
    updateCreateClaimModalVisibility
} from './create-claim-modal';
import {
    resetProduct,
    updateProduct,
    updateStatusChangeModalVisibility
} from './status-change-modal';
import exportToExcelActions from '../../../shared/action-creators/excel-layout-modal-actions-combined';
import {goToStatusChangeRequestView} from '../../shared/action-creators/status-change-request-view';
import {readCustomer} from './read-customer';
import {readProductsByCustomer} from './read-products-by-customer';
import {resetCustomer} from './reset-customer';
import {resetProductsByCustomer} from './reset-products-by-customer';
import {updateCustomerEditModalVisibility} from './customer-edit-modal-visibility';
import {updateCustomerSearchModalVisibility} from './customer-search-modal-visibility';
import {updateSearchFilters} from './search-filters';
import {updateShowPartialDataWarning} from './partial-data-warning';

export default {
    ...exportToExcelActions,
    getClaimTypesList,
    goToStatusChangeRequestView,
    onCreateClaim,
    readCustomer,
    readProductsByCustomer,
    resetCustomer,
    resetProduct,
    resetProductsByCustomer,
    updateCreateClaimModalVisibility,
    updateCustomerEditModalVisibility,
    updateCustomerSearchModalVisibility,
    updateProduct,
    updateSearchFilters,
    updateShowPartialDataWarning,
    updateStatusChangeModalVisibility
};



// WEBPACK FOOTER //
// ./src/product/products-by-customer/action-creators/index.js